import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51ba9d03"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "payment-info-wrapper seat-selectable"
}
const _hoisted_2 = { class: "payment-info-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "결제금액", -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "fare-calculation"
}
const _hoisted_5 = { class: "total-fare" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!!$props.bookingDatesCount)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            ($props.currentBookInterval === $setup.BookIntervalCode.DAY)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.getFareCalculationStr()), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("span", _hoisted_5, _toDisplayString($setup.useCurrencyFormat($props.totalAmount)) + "원 ", 1 /* TEXT */)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}